import React, { useState } from 'react';
import 'react-image-gallery/styles/css/image-gallery.css';

export interface GalleryImage {
  src: string;
  category: string;
  description: string;
}

const Gallery: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const images: GalleryImage[] = [
    {
      src: 'https://annschaeferchildcare.com/images/gallery/IMG_3121.JPG',
      category: 'indoor',
      description: 'Indoor activities and learning environment'
    }
  ];

  const filteredImages = selectedCategory === 'all'
    ? images
    : images.filter(img => img.category === selectedCategory);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold text-clay-500 mb-8 text-center">
        Photo Gallery
      </h1>
      
      <div className="flex justify-center gap-4 mb-8">
        <button
          onClick={() => setSelectedCategory('all')}
          className={`px-4 py-2 rounded-lg ${
            selectedCategory === 'all' ? 'bg-clay-500 text-white' : 'bg-gray-100'
          }`}
        >
          All
        </button>
        <button
          onClick={() => setSelectedCategory('indoor')}
          className={`px-4 py-2 rounded-lg ${
            selectedCategory === 'indoor' ? 'bg-clay-500 text-white' : 'bg-gray-100'
          }`}
        >
          Indoor Activities
        </button>
        <button
          onClick={() => setSelectedCategory('outdoor')}
          className={`px-4 py-2 rounded-lg ${
            selectedCategory === 'outdoor' ? 'bg-clay-500 text-white' : 'bg-gray-100'
          }`}
        >
          Outdoor Activities
        </button>
        <button
          onClick={() => setSelectedCategory('learning')}
          className={`px-4 py-2 rounded-lg ${
            selectedCategory === 'learning' ? 'bg-clay-500 text-white' : 'bg-gray-100'
          }`}
        >
          Learning Materials
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredImages.map((image, index) => (
          <div key={image.src} className="relative group">
            <img
              src={image.src}
              alt={image.description}
              className="w-full h-64 object-cover rounded-lg shadow-md"
            />
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-black bg-opacity-50 text-white rounded-b-lg opacity-0 group-hover:opacity-100 transition-opacity">
              {image.description}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery; 